<template>
  <div class="row_center_center general_type">會員</div>
</template>
<style lang="scss" scope>
.general_type {
  height: 24px;
  padding: 0px 8px;
  background-color: #c4c4c4;
  border-radius: 30px;
  font-size: 12px;
  font-family: PingFang SC;
}
</style>
